module.exports = __webpack_public_path__ + "static/media/fullstack.cf272346.svg";